<template>
    <div>
        <svg v-if="status === 'val'" xmlns="http://www.w3.org/2000/svg" width="100px" height="50px">
            <text x="10" y="20" style="font-family: Times New Roman; font-size : 24px;" :stroke="color">VAL</text>
        </svg>
        <svg v-if="status === 'sub'" xmlns="http://www.w3.org/2000/svg" width="100px" height="50px">
            <text x="10" y="20" style="font-family: Times New Roman; font-size : 24px;" :stroke="color">SUB</text>
        </svg>
        <svg v-if="status === 're'" xmlns="http://www.w3.org/2000/svg" width="100px" height="50px">
            <text x="10" y="20" style="font-family: Times New Roman; font-size : 24px;" :stroke="color">RE</text>
        </svg>
    </div>
</template>
<script>
export default {
    props: {
        status: {
            type: String,
            required: true
        },
        color: {
            type: String,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// StatusIcon.vue?b93fb8e4